module.exports = __webpack_public_path__ + "media/images/email/ic_outlook-88d6577f876239228c04535680495c96.png";